module.exports = __webpack_public_path__ + "img/profile-simon.a9086a07.png";